import { Box, useTheme } from "@mui/material";

type FooterLink = {
  id: number;
  href: string;
  displayText: string;
};

const staticFooterLinks: FooterLink[] = [
  {
    id: 1,
    href: 'https://www.vytlone.com/hipaa',
    displayText: 'HIPAA Notice of Privacy Practices'
  },
  {
    id: 2,
    href: 'https://www.vytlone.com/privacy-policy',
    displayText: 'Website Privacy Policy'
  },
  // {
  //   href: 'https://www.maxor.com/maxorplus/',
  //   displayText: 'Learn About MaxorPlus'
  // },
  // {
  //   href: 'https://www.maxor.com/maxorplus/contact-us',
  //   displayText: 'Contact Us'
  // }
];

type DynamicFooterData = {
  AboutClientUrlFooter?: string;
  AboutClientMessageFooter?: string;
  ContactUsUrlFooter?: string;
};

type FooterProps = {
  dynamicFooterData?: DynamicFooterData;
};

const Footer = ({ dynamicFooterData }: FooterProps) => {
  const theme = useTheme();

  const footerLinks: FooterLink[] = [...staticFooterLinks];
  if( dynamicFooterData ) {
    if( dynamicFooterData.AboutClientUrlFooter && dynamicFooterData.AboutClientMessageFooter ) {
      footerLinks.push({
        id: 3,
        href: dynamicFooterData.AboutClientUrlFooter,
        displayText: dynamicFooterData.AboutClientMessageFooter
      });
    }
    if( dynamicFooterData.ContactUsUrlFooter ) {
      footerLinks.push({
        id: 4,
        href: dynamicFooterData.ContactUsUrlFooter,
        displayText: 'Contact Us'
      });
    }
  }
  const footerLinksList = footerLinks.map( footer =>
    <a className="footer-link" href={footer.href} target="_blank" rel="noreferrer" key={footer.id}>
      {footer.displayText}
    </a>
  );

  return (
    <Box id="footer-box" sx={{
        p:2,
        flexGrow: 1,
        bgcolor: '#373737',
        color: '#FAFAFA'
      }}>
      <Box sx={{ pt: 2, borderTop: '1px solid white' }}>
        { footerLinksList }
      </Box>
      <Box pt={1}>© 2026 VytlOne. All Rights Reserved.</Box>
    </Box>
  )
}

export default Footer;